import { useLocale, useTranslations } from 'next-intl';

import { EventType } from '@/analytics/types';
import ArticleCardsModule from '@/app/components/ArticleCardsModule';
import ArticleCardTag from '@/app/components/ArticleCardsModule/ArticleCardTag';
import getLocalePartialUrl from '@/utils/getLocalePartialUrl';

import {
  activityAndMovementFooterCards,
  activityAndMovementFooterImageData,
} from '../_data/activityAndMovementFooterData';

const ActivityAndMovementFooter = () => {
  const t = useTranslations();
  const locale = useLocale();
  const articleImage = activityAndMovementFooterImageData(
    getLocalePartialUrl(locale),
  );
  const articleCards = activityAndMovementFooterCards(
    getLocalePartialUrl(locale),
  );

  const handleLinkClick = async (
    event: React.MouseEvent<HTMLAnchorElement>,
  ): Promise<void> => {
    const { href } = event.currentTarget;
    const { pathname } = new URL(href);

    await window.ouraAnalytics.track(EventType.LinkClicked, {
      cta: 'read_more',
      location: 'activity and movement footer',
      path: pathname,
    });
  };

  return (
    <ArticleCardsModule
      articleImage={articleImage}
      articleCards={articleCards}
      data-cy="activity-and-movement-footer"
      eyebrowText="pulse_blog_eyebrow"
      eyebrowTextColor="dark"
      imageTag={() => (
        <ArticleCardTag tag="featured_article_tag" textColor="text-brown-500" />
      )}
      mobileSliderAriaLabels={[
        t('acitivy_article_one'),
        t('acitivy_article_two'),
        t('acitivy_article_three'),
      ]}
      onClick={handleLinkClick}
      swipeableDotsProps={{
        activeColor: 'sandstone-200',
        color: 'sandstone-500',
      }}
      wrapperClass="bg-[#E1BA8B] text-brown-500"
    />
  );
};

export default ActivityAndMovementFooter;
